const query = document.querySelector.bind(document);

/**
 * Initializes the mobile menu functionality
 * Handles toggling the mobile menu, click outside to close, and scroll behavior
 */
function initMenu() {
    // console.log("CareerReady :: Init Menu");

    const mobileMenuTrigger = document.querySelector('.mobile-menu-trigger');
    const siteHeader = document.querySelector('.site-header');
    const siteLogo = document.querySelector('.site-title');
    const heroBlock = document.querySelector('.cr-hero-block');
    
    if (!mobileMenuTrigger || !siteHeader) return;
        
    const hideNavLogo = (heroBlock) ? heroBlock.getAttribute('data-hidelogo') : false;
    
    // Setup IntersectionObserver for logo opacity animation when hideNavLogo is enabled
    if (hideNavLogo && siteLogo && heroBlock) {
        // Add Tailwind transition class to siteLogo
        siteLogo.classList.add('transition-opacity', 'duration-300', 'ease-in-out');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Hero block is in view - fade logo to opacity 0
                    siteLogo.classList.remove('opacity-100');
                    siteLogo.classList.add('opacity-0');
                } else {
                    // Hero block is not in view - fade logo to opacity 1
                    siteLogo.classList.remove('opacity-0');
                    siteLogo.classList.add('opacity-100');
                }
            });
        }, {
            threshold: 0.1
        });
        
        setTimeout( ()=> {query('.start-hidden').style.opacity = '1';}, 300);

        observer.observe(heroBlock);
    }

    mobileMenuTrigger.addEventListener('click', () => {
        siteHeader.classList.toggle('expanded');
    });

    window.addEventListener('resize', () => {
        siteHeader.classList.remove('expanded');
    });

    document.addEventListener('click', (e) => {
        return;
        if (!mobileMenuTrigger.contains(e.target) && !mobileMenu.contains(e.target)) {
            siteHeader.classList.remove('expanded');
        }
    });

    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
    
        if (siteHeader.classList.contains('expanded')) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 200 && (scrollTop > lastScrollTop)) {
            if (!siteHeader.hidden) gsap.to(siteHeader, {  y: -siteHeader.offsetHeight, duration: 0.5, ease: 'expo.in' });
            siteHeader.hidden = true;
        } else {
            if (siteHeader.hidden) gsap.to(siteHeader, {  y: 0, duration: 0.5, ease: 'expo.out' });
            siteHeader.hidden = false;
        }

        ( scrollTop > 20 ) ? siteHeader.classList.add('scrolled') : siteHeader.classList.remove('scrolled');

        lastScrollTop = scrollTop;
    });


    if( window.scrollY > 20 ) {
        siteHeader.classList.add('scrolled');
    }
}

export default initMenu;
